<template>
  <div class="quote-terms-display">
    <!-- Default Contract Section -->
    <div v-if="defaultContract && defaultContract.content" class="default-contract-section">
      <div class="terms-content" v-html="defaultContract.content"></div>
    </div>

    <!-- Additional Terms Section -->
    <div v-if="additionalTerms && additionalTerms.length > 0" class="additional-terms-section">
      <div 
        v-for="(term, index) in sortedTerms" 
        :key="`term-${index}`" 
        class="term-item"
      >
        <h2>{{ term.name }}</h2>
        <div v-if="term.content" v-html="term.content"></div>
        <div v-else>
          <p>No additional details provided for this term.</p>
        </div>
      </div>
    </div>

    <!-- No Terms Message -->
    <div v-if="!hasAnyTerms" class="no-terms-message">
      <p class="text-muted">No terms and conditions available.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuoteTermsDisplay",
  props: {
    defaultContract: {
      type: Object,
      default: null
    },
    additionalTerms: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    sortedTerms() {
      if (!this.additionalTerms || !Array.isArray(this.additionalTerms)) {
        return [];
      }
      return this.additionalTerms
        .filter(term => term && term.name && term.content)
        .sort((a, b) => (a.order || 0) - (b.order || 0));
    },
    hasAnyTerms() {
      const hasDefault = this.defaultContract && this.defaultContract.content;
      const hasAdditional = this.sortedTerms.length > 0;
      return hasDefault || hasAdditional;
    }
  }
};
</script>

<style scoped>
.quote-terms-display {
  padding: 20px 0;
}

.default-contract-section {
  margin-bottom: 40px;
  padding-bottom: 30px;
  border-bottom: 2px solid #e9ecef;
}

.additional-terms-section {
  margin-top: 30px;
}

.term-item {
  margin-bottom: 20px;
}

.term-item h5 {
  margin-top: 0;
  margin-bottom: 10px;
  font-weight: 600;
}

.no-terms-message {
  text-align: center;
  padding: 40px 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px dashed #dee2e6;
}
</style>